exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[class^=share-network-]{color:#fff;border-radius:3px;overflow:hidden;display:inline-block;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;margin:0 10px 10px 0;width:180px}a[class^=share-network-] .fah{background-color:rgba(0,0,0,.2);padding:10px}a[class^=share-network-] span{padding:0 10px;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13c0e16d","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/dashboard/Share.vue
// module id = HqF7
// module chunks = 0